// Button Component - Fixed
import React from 'react';
import './Button.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  children,
  className = '',
  ...props
}) => {
  const buttonClass = [
    'artifi-button',
    `button-${variant}`,
    `button-${size}`,
    loading ? 'button-loading' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      className={buttonClass}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <div className="spinner" />}
      <span className={loading ? 'button-content-hidden' : ''}>{children}</span>
    </button>
  );
};

export default Button;